export const QUICK_ACTION_RELATION = 10
export const QUICK_ACTION_DEPUTIZE = 20
export const QUICK_ACTION_REPORTER_RELATION = 30
export const QUICK_ACTION_FAMILY = 50
export const QUICK_ACTION_DEPUTIZE_AGENT = 60
